var EHDI = EHDI || Object.create(null);

EHDI.GameStateEnum = {
  GAMEINITIALIZING: 0,
  GAMESTARTED: 1,
  GAMEPAUSED: 2,
  GAMERESUMED: 3,
  GAMEOVER: 4,
};

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function () {
    EHDI.Scene.call(this);
  };

EHDI.scene.GameScene.prototype = Object.create(EHDI.Scene.prototype);

EHDI.scene.GameScene.prototype.screenWillAppear = function () {
  this.init();
};

EHDI.scene.GameScene.prototype.popUpWillAppear = function() {
  EHDI.GAME.soundManager.pauseBGM();
  EHDI.GAME.soundManager.pauseAllSFX();
};

EHDI.scene.GameScene.prototype.popUpDidDisappear = function() {
  EHDI.GAME.soundManager.resumeBGM();
  EHDI.GAME.soundManager.resumeAllSFX();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function () {
  var cache = EHDI.GAME.saveData;

  this.startGame();
  if(EHDI.GAME.saveData.isFirstTimePlay)
  {
    EHDI.GAME.saveData.isFirstTimePlay = false;
    EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
    /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
          console.log("data saved.");
      }); */
    EHDI.GAME.pauseButton.isPaused = true;
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
  }
}


EHDI.scene.GameScene.prototype.init = function () {
    this.initProps();
    this.initGraphics();
    this.initListeners();
  };

EHDI.scene.GameScene.prototype.initProps = function () {
  this._gameState;
  this._platformData;
  this._collectibleData;
  this._collectibleRawData;
  this._gameWidth = 1024;
  this._gameHeight = 600;
  this._currentGameDistance = 0;
  this._tails = [];
  this._removeATail = false;
  this._finishLine = 1200;
  this._platformScrollLimit = 18000 - 280;
  this._splashEffects = [];
  this._clouds = [];
  this._pathTemplates;

  this._deltaTotal = 0;
  this._deltaLimit = 25;
  this._deltaMultiplier = 0;
  this._noahVisible = false;

  this._pickupAnimation;

  this._floodPenaltyTimer;
  this._floodPenaltyVal = 3000;

  this._gameState = EHDI.GameStateEnum.GAMEINITIALIZING;

  if (this._floodPenaltyTimer == null) {
    this._floodPenaltyTimer = new EHDI.util.Time();
  }

  if (this._platformData == undefined) {
    this._platformData = [
      [EHDI.PTypeEnum.PA7,  0],
      [EHDI.PTypeEnum.PB6,  7],
      [EHDI.PTypeEnum.PA3,  8],
      [EHDI.PTypeEnum.PA5,  12],
      [EHDI.PTypeEnum.PC5,  14],
      [EHDI.PTypeEnum.PA7,  18],
      [EHDI.PTypeEnum.PD4,  19],
      [EHDI.PTypeEnum.PB4,  21],
      [EHDI.PTypeEnum.PC4,  24],
      [EHDI.PTypeEnum.PA3,  27],
      [EHDI.PTypeEnum.PD6,  29],

      [EHDI.PTypeEnum.PA5,  31],
      [EHDI.PTypeEnum.PC4,  36],
      [EHDI.PTypeEnum.PB6,  37],
      [EHDI.PTypeEnum.PA5,  40],
      [EHDI.PTypeEnum.PC4,  44],
      [EHDI.PTypeEnum.PA3,  46],
      [EHDI.PTypeEnum.PC4,  50],
      [EHDI.PTypeEnum.PA5,  50],
      [EHDI.PTypeEnum.PB6,  56],

      [EHDI.PTypeEnum.PA5,  60],
      [EHDI.PTypeEnum.PC4,  60],
      [EHDI.PTypeEnum.PD6,  64],
      [EHDI.PTypeEnum.PA5,  66],
      [EHDI.PTypeEnum.PB4,  67],
      [EHDI.PTypeEnum.PC5,  72],
      [EHDI.PTypeEnum.PA3,  73],
      [EHDI.PTypeEnum.PA3,  78],
      [EHDI.PTypeEnum.PB4,  79],
      [EHDI.PTypeEnum.PC4,  80],
      [EHDI.PTypeEnum.PA3,  82],
      [EHDI.PTypeEnum.PD6,  84],
      [EHDI.PTypeEnum.PA5,  86],

      [EHDI.PTypeEnum.PB4,  91],
      [EHDI.PTypeEnum.PA3,  94],
      [EHDI.PTypeEnum.PC5,  96],
      [EHDI.PTypeEnum.PA5,  98],
      [EHDI.PTypeEnum.PD6,  102],
      [EHDI.PTypeEnum.PA3,  105],
      [EHDI.PTypeEnum.PB6,  108],
      [EHDI.PTypeEnum.PC5,  110],
      [EHDI.PTypeEnum.PA5,  111],
      [EHDI.PTypeEnum.PD4,  116],
      [EHDI.PTypeEnum.PA3,  117],

      [EHDI.PTypeEnum.PA5,  121],
      [EHDI.PTypeEnum.PB4,  122],
      [EHDI.PTypeEnum.PC4,  122],
      [EHDI.PTypeEnum.PD6,  124],
      [EHDI.PTypeEnum.PA3,  128],
      [EHDI.PTypeEnum.PC4,  131],
      [EHDI.PTypeEnum.PA3,  132],
      [EHDI.PTypeEnum.PA3,  136],
      [EHDI.PTypeEnum.PD4,  136],
      [EHDI.PTypeEnum.PB4,  137],
      [EHDI.PTypeEnum.PA5,  141],
      [EHDI.PTypeEnum.PC4,  142],
      [EHDI.PTypeEnum.PA3,  147],
      [EHDI.PTypeEnum.PC4,  147],

      [EHDI.PTypeEnum.PA5,  151],
      [EHDI.PTypeEnum.PB4,  153],
      [EHDI.PTypeEnum.PA7,  157],
      [EHDI.PTypeEnum.PC5,  158],
      [EHDI.PTypeEnum.PC5,  164],
      [EHDI.PTypeEnum.PA3,  165],
      [EHDI.PTypeEnum.PB4,  169],
      [EHDI.PTypeEnum.PD4,  170],
      [EHDI.PTypeEnum.PA3,  171],
      [EHDI.PTypeEnum.PC4,  171],
      [EHDI.PTypeEnum.PA7,  175],
      [EHDI.PTypeEnum.PB4,  179],

      [EHDI.PTypeEnum.PC4,  180],
      [EHDI.PTypeEnum.PE1,  184],
      // [EHDI.PTypeEnum.PE1,  180],

      // [EHDI.PTypeEnum.PS2,  50,  600],
      // [EHDI.PTypeEnum.PS1,  50,  600],
      // [EHDI.PTypeEnum.PS2,  50,  600],
      // [EHDI.PTypeEnum.PS1,  50,  600],
    ];

    if (this._pathTemplates == undefined) {
      this._pathTemplates = [[1,0,1,0,1,0,1,0,1,0],
                             [1,0,0,1,1,0,0,1,1,0],
                             [0,1,1,0,1,1,0,1,0,1]];
    }

    if (this._collectibleRawData == undefined) {
      this._collectibleRawData = [[[EHDI.ColTypeEnum.COL11, 18, 500],
                                [EHDI.ColTypeEnum.COL11, 34, 500],
                                [EHDI.ColTypeEnum.COL11, 54, 500],
                                [EHDI.ColTypeEnum.COL11, 74, 500],
                                [EHDI.ColTypeEnum.COL11, 89, 500],
                                [EHDI.ColTypeEnum.COL11, 101, 500],
                                [EHDI.ColTypeEnum.COL11, 115, 500],
                                [EHDI.ColTypeEnum.COL11, 128, 500],
                                [EHDI.ColTypeEnum.COL11, 149, 500],
                                [EHDI.ColTypeEnum.COL11, 167, 500]],

                               [[EHDI.ColTypeEnum.COL11, 22, 200],
                                [EHDI.ColTypeEnum.COL11, 36, 300],
                                [EHDI.ColTypeEnum.COL11, 53, 300],
                                [EHDI.ColTypeEnum.COL11, 74, 300],
                                [EHDI.ColTypeEnum.COL11, 89, 200],
                                [EHDI.ColTypeEnum.COL11, 107, 200],
                                [EHDI.ColTypeEnum.COL11, 118, 200],
                                [EHDI.ColTypeEnum.COL11, 133, 300],
                                [EHDI.ColTypeEnum.COL11, 150, 300],
                                [EHDI.ColTypeEnum.COL11, 168, 300]]];
      for (var i = 0; i < 2; i++) {
        for (var j = 0; j < 10; j++) {
          this._collectibleRawData[i][j][1] *= 100;
          this._collectibleRawData[i][j][1] += 50;
        }
      }
    }

    // if (this._collectibleData == undefined) {
      // this._collectibleData = [[EHDI.ColTypeEnum.COL11, 8, 400],
      //                         [EHDI.ColTypeEnum.COL11, 26, 300],
      //                         [EHDI.ColTypeEnum.COL11, 53, 500],
      //                         [EHDI.ColTypeEnum.COL11, 74, 300],
      //                         [EHDI.ColTypeEnum.COL11, 106, 200],
      //                         [EHDI.ColTypeEnum.COL11, 118, 500],
      //                         [EHDI.ColTypeEnum.COL11, 128, 500],
      //                         [EHDI.ColTypeEnum.COL11, 144, 300],
      //                         [EHDI.ColTypeEnum.COL11, 153, 200],
      //                         [EHDI.ColTypeEnum.COL11, 162, 400]];

      // this._collectibleData = this._collectibleRawData[0];
    // }

    for (var i = 0; i < this._platformData.length; i++) {
      this._platformData[i][1] *= 100;

      // if (this._platformData[i][2] != undefined) {
      //   this._platformData[i][2][1] *= 100;
      //   this._platformData[i][2][1] += 50;
      // }
    }
  }

  this._collectibleData = [];

  var randomNumber = Math.floor(Math.random() * this._pathTemplates.length);

  this._collectibleData = this._collectibleData.concat(this._pathTemplates[randomNumber])

  for (var i = 0; i < this._pathTemplates[randomNumber].length; i++) {
    this._collectibleData.push(this._collectibleRawData[this._pathTemplates[randomNumber][i]][i]);
  }
};

EHDI.scene.GameScene.prototype.initGraphics = function () {
  this._hudContainer;
  this._backgroundContainer;
  this._gameContainer;
  this._foregroundContainer;

  this._hudHighScoreHolder;
  this._hudPauseButton;
  this._scoreContainer;

  this._backgroundTexture;
  this._backgroundTilingSprite;
  this._backgroundRainTexture;
  this._backgroundRainTilingSprite;
  this._backgroundFastRainTilingSprite;

  this._noahTexture;
  this._noahSprite;
  this._noahsTimeLine;

  this._tailTimeline;
  this._floodAnimation;

  this._character;
  this._platformContainer;

  if (this._backgroundTexture == null) {
    this._backgroundTexture = EHDI.Assets.images['bg_flood'];
  }


  if (this._backgroundRainTexture == null) {

    var floodTextureContainer = new EHDI.aka.Container();
    // var rainDrop = EHDI.Assets.images['rain'];
    var rainTexture = EHDI.Assets.images['rain']
    var sprite;

    for (var i = 0; i < 20; i++) {
      sprite = new EHDI.aka.Sprite(rainTexture);

      sprite.rotation = 10;
      sprite.x = Math.random() * 500;
      sprite.y = Math.random() * 500;

      floodTextureContainer.addChild(sprite);
    }

    this._backgroundRainTexture = EHDI.GAME.sceneManager.getRenderer().generateTexture(floodTextureContainer,1,1);
  };

  if (this._backgroundContainer == null) {
    this._backgroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._backgroundContainer);
  }

  if (this._backgroundTilingSprite == null) {
    this._backgroundTilingSprite =
    new EHDI.aka.TilingSprite(this._backgroundTexture, 1024, 600);

    this._backgroundTilingSprite.x = 0;
    this._backgroundTilingSprite.y = 0;

    this._backgroundContainer.addChildAt(this._backgroundTilingSprite, 0);
  }

  if (this._noahTexture == null) {
    this._noahTexture = EHDI.Assets.images['ark_joyandchris'];
  }

  if (this._noahSprite == null) {
    this._noahSprite = new EHDI.aka.Sprite(this._noahTexture);

    this._noahSprite.x = 730;
    this._noahSprite.y = 100;

    this._backgroundContainer.addChild(this._noahSprite);
  }

  if (this._clouds.length == 0) {
    for(var i = 0; i < 2; i++) {
      var cloud = EHDI.GetGlobalPool().cloudPool.get();
      cloud.init(i%2);

      cloud.x = 1024 * i;
      cloud.y = Math.random() * 30;

      this._clouds.push(cloud);

      this._backgroundContainer.addChildAt(cloud, 1);
    }
  }

  this._noahSprite.visible = false;

  if (this._gameContainer == null) {
    this._gameContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._gameContainer);
  }

  if (this._platformContainer == null) {
    this._platformContainer = EHDI.GetGlobalPool().containerPool.get();

    this._gameContainer.addChildAt(this._platformContainer, 0);
  } else {
    this._platformContainer.x = 0;
  }

  this.initLevel();

  if (this._character == null) {
    this._character = EHDI.GetGlobalPool().charPool.get();;
    this._character.init();

    this._gameContainer.addChild(this._character);
  }

  if (this._foregroundContainer == null) {
    this._foregroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._foregroundContainer);
  }

  if (this._backgroundFastRainTilingSprite == undefined) {
    this._backgroundFastRainTilingSprite =
    new EHDI.aka.TilingSprite(this._backgroundRainTexture, 1024, 600);

    this._backgroundFastRainTilingSprite.x = 0;
    this._backgroundFastRainTilingSprite.y = 0;

    this._foregroundContainer.addChild(this._backgroundFastRainTilingSprite);
  }

  if (this._floodAnimation == null) {
    this._floodAnimation = EHDI.GetGlobalPool().effectsPool.get();

    this._floodAnimation.init('fx_flood_wave');

    this._floodAnimation.updatePos(512, 600)
    this._floodAnimation.changeAnimation();

    this._foregroundContainer.addChild(this._floodAnimation.getDisplay());

    this._foregroundContainer.width = 1030;
    this._foregroundContainer.x = -3;
    // this._foregroundContainer.addChild(this._foregroundFloodSprite);
  }

  if (this._backgroundRainTilingSprite == null) {
    this._backgroundRainTilingSprite =
    new EHDI.aka.TilingSprite(this._backgroundRainTexture, 1024, 600);

    this._backgroundRainTilingSprite.x = 0;
    this._backgroundRainTilingSprite.y = 0;

    // this._backgroundContainer.addChild(this._backgroundRainTilingSprite);
  };

  if (this._hudContainer == null) {
    this._hudContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._hudContainer);
  }

  if (this._scoreContainer == null) {
    this._scoreContainer = new EHDI.components.ScoreManager(this._hudContainer);
    this._scoreContainer.setXY(10,10);
  }

  if (this._hudPauseButton == null) {
    this._hudPauseButton = new EHDI.components.pauseButton();

    this._hudContainer.addChild(this._hudPauseButton);
  }

  if (this._pickupAnimation == null) {
    this._pickupAnimation = EHDI.GetGlobalPool().effectsPool.get();
    this._pickupAnimation.init('fx_pickup');

    this._pickupAnimation.getDisplay().x = -100;

    this._hudContainer.addChild(this._pickupAnimation.getDisplay());
  }

  // if (this.testAnimation == null) {
  //   this.testAnimation = EHDI.GetGlobalPool().effectsPool.get();
  //   this.testAnimation.init('fx_wave');
  //   this.testAnimation.changeAnimation(true);
  //   this.testAnimation.getDisplay().x = 100;
  //   this.testAnimation.getDisplay().y = 100;
  //
  //   this._hudContainer.addChild(this.testAnimation.getDisplay());
  // }
};

EHDI.scene.GameScene.prototype.destroyGraphics = function () {
  if (this._noahsTimeLine != null) {
    this._noahsTimeLine.kill();
  }
  delete this._noahsTimeLine;
  this._noahsTimeLine = null;

  if(this._pickupAnimation != null)
  {
    this._hudContainer.removeChild(this._pickupAnimation);
  }
  delete this._pickupAnimation;
  this._pickupAnimation = null;

  if (this._hudPauseButton != null) {
    this._hudContainer.removeChild(this._hudPauseButton);
    this._hudPauseButton.destroy({children: true});
  }
  delete this._hudPauseButton;
  this._hudPauseButton = null;

  if (this._scoreContainer != null) {
    this._scoreContainer.dispose();
    this._scoreContainer = null;
  }
  delete this._scoreContainer;
  this._scoreContainer = null;

  //
  // if (this._hudContainer != null) {
  //   this.removeChild(this._hudContainer);
  //   EHDI.GetGlobalPool().containerPool.return(this._hudContainer);
  // }

  if(this._backgroundRainTilingSprite != null)
  {
    this._backgroundRainTilingSprite.destroy({children: true});
  }
  delete this._backgroundRainTilingSprite;
  this._backgroundRainTilingSprite = null;

  if(this._floodAnimation != null)
  {
    this._foregroundContainer.removeChild(this._floodAnimation);
    this._floodAnimation.reset();
  }
  delete this._floodAnimation;
  this._floodAnimation = null;

  if(this._backgroundFastRainTilingSprite != null)
  {
    this._foregroundContainer.removeChild(this._backgroundFastRainTilingSprite);
    this._backgroundFastRainTilingSprite.destroy({children: true});
  }
  delete this._backgroundFastRainTilingSprite;
  this._backgroundFastRainTilingSprite = null;

  // if (this._foregroundContainer != null) {
  //   this.removeChild(this._foregroundContainer);
  //   EHDI.GetGlobalPool().containerPool.return(this._foregroundContainer);
  // }

  if (this._character != null) {
    this._gameContainer.removeChild(this._character);
    EHDI.GetGlobalPool().charPool.return(this._character);
  }
  delete this._character;
  this._character = null;

  this.destroyLevel();

  // if (this._platformContainer != null) {
  //   this._gameContainer.removeChild(this._platformContainer);
  //   EHDI.GetGlobalPool().containerPool.get(this._platformContainer);
  //   this._platformContainer = null;
  // }

  if (this._tails != null) {
    while (this._tails.length > 0) {
      var tail = this._tails.pop();

      if (tail.parent != null)
        tail.parent.removeChild(tail);

      EHDI.GetGlobalPool().tailPool.return(tail);
      tail = null;
    }
  }

  if (this._clouds != null) {
    while (this._clouds.length > 0) {
      var cloud = this._clouds.pop();

      if (cloud.parent != null)
        cloud.parent.removeChild(tail);

      EHDI.GetGlobalPool().cloudPool.return(cloud);
      cloud = null;
    }
  }

  // if (this._gameContainer != null) {
  //   this.removeChild(this._gameContainer);
  //   EHDI.GetGlobalPool().containerPool.return(this._gameContainer);
  //   this._gameContainer = null;
  // }

  // if (this._backgroundContainer != null) {
  //   this.removeChild(this._backgroundContainer);
  //   EHDI.GetGlobalPool().containerPool.return(this._backgroundContainer);
  //   this._backgroundContainer = null;
  // }

  if (this._splashEffects != null) {
    while (this._splashEffects.length > 0) {
      var splash = this._splashEffects.pop();

      EHDI.GetGlobalPool().splashPool.return(splash);
      tail = null;
    }
  }

  if(this._noahSprite != null)
  {
    this._backgroundContainer.removeChild(this._noahSprite);
    this._noahSprite.destroy({children: true});
  }
  delete this._noahSprite;
  this._noahSprite = null;

  // if(this._noahTexture != null)
  // {
  //   this._noahTexture.destroy({children: true});
  // }
  // delete this._noahTexture;
  // this._noahTexture = null;

  if (this._backgroundTilingSprite != null) {
    this._backgroundContainer.removeChild(this._backgroundTilingSprite);
    this._backgroundTilingSprite.destroy({children: true});
  }
  delete this._backgroundTilingSprite;
  this._backgroundTilingSprite = null;

  if(this._backgroundRainTexture != null)
  {
    this._backgroundRainTexture.destroy({children: true});
  }
  delete this._backgroundRainTexture;
  this._backgroundRainTexture = null;

};

EHDI.scene.GameScene.prototype.initListeners = function () {
  // EHDI.GAME.updateManager.addFrameListener();
  // console.log(EHDI.GAME.updateManager.hasFrameListener(this.update.bind(this)));

  if (this._ticker == null) {
    this._ticker = new EHDI.aka.Ticker();
  }

  if (this.updateWithBind == null)
    this.updateWithBind = this.update.bind(this);

  this._ticker.add(this.updateWithBind);
  this._ticker.start();

  if (EHDI.BrowserInfo.isMobileDevice) {
    this.interactive = true;
    this.onTouchWithBind = this._handler_onTouch.bind(this);
    this.on('pointerdown', this.onTouchWithBind);
  } else {
    this.onKeyWithBind = this._handler_onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyWithBind);
  }
};

EHDI.scene.GameScene.prototype.destroyListeners = function () {
  this._ticker.remove(this.updateWithBind);
  this._ticker.stop();

  if (EHDI.BrowserInfo.isMobileDevice) {
    this.interactive = false;
    this.off('pointerdown', this.onTouchWithBind);
  } else {
    window.removeEventListener('keydown', this.onKeyWithBind);
  }
};

EHDI.scene.GameScene.prototype.startGame = function () {
  this._character.start();
  this._floodAnimation.play();

  this.gameStateManager(EHDI.GameStateEnum.GAMESTARTED);
};

EHDI.scene.GameScene.prototype.gameStateManager = function (newState) {
  if (this._gameState != newState) {
    this._gameState = newState;
  }
};

EHDI.scene.GameScene.prototype.addCollectibleData = function (platform, data) {

  if (data[0] == EHDI.ColTypeEnum.COL11) {
    this._collectibleData.push([this._listOfCollectibles.pop(), data[1], platform.getTopYPos()]);
  } else {
    this._collectibleData.push([data[0], data[1], platform.getTopYPos()]);
  }
};

EHDI.scene.GameScene.prototype.manageAnimals = function () {
   var collectibles = [EHDI.ColTypeEnum.COL1, EHDI.ColTypeEnum.COL2, EHDI.ColTypeEnum.COL3,
                       EHDI.ColTypeEnum.COL4, EHDI.ColTypeEnum.COL5, EHDI.ColTypeEnum.COL6,
                       EHDI.ColTypeEnum.COL7, EHDI.ColTypeEnum.COL8, EHDI.ColTypeEnum.COL9,
                       EHDI.ColTypeEnum.COL10];

   var numberOfPairs = 5;
   var enablePairs = [];
   this._listOfCollectibles = [];

   for (var i = 0; i < 5; i++) {
     var randomNumber = Math.floor(Math.random() * collectibles.length);
     var collectible = collectibles[randomNumber];

     if (randomNumber > -1)
      collectibles.splice(randomNumber, 1);

     enablePairs.push(collectible);
   }

   for (var i = 0; i < enablePairs.length; i++) {
     var collectible = enablePairs[i];
     this._listOfCollectibles.push(collectible);
   }

   for (var i = 0; i < enablePairs.length; i++) {
     var collectible = enablePairs[i];
     this._listOfCollectibles.push(collectible);
   }

   for (var i = 0; i < this._collectibleData.length; i++) {
     if (this._collectibleData[i][0] == EHDI.ColTypeEnum.COL11) {
       this._collectibleData[i][0] = this._listOfCollectibles.pop();
     }
   }
}

EHDI.scene.GameScene.prototype.initLevel = function () {
  this._platforms = [];
  this._activePlatforms = [];
  this._currentPlatform;
  this.manageAnimals();

  var dataLength = this._platformData.length;

  var platform;
  // var platform = EHDI.GetGlobalPool().platformPool.get();
  // platform.init(
  // this._platformData[0][0],
  // this._platformData[0][1],
  // this._platformData[0][2]);
  //
  // if (this._platformData[0][3] != undefined)
  // {
  //   this.addCollectibleData(platform, this._platformData[0][3]);
  // }
  //
  // this._platforms.push(platform);

  for (var i = 0; i < dataLength; i++) {
    platform = EHDI.GetGlobalPool().platformPool.get();

    platform.init(
    this._platformData[i][0],
    this._platformData[i][1],
    this._gameHeight);

    this._platforms.push(platform);
  }

  this.updateActivePlatform();
  this.initCollectibles();
  // for (var i = 0; i < this._platforms.length; i++) {
  //   this._platformContainer.addChild(this._platforms[i]);
  // }
};

EHDI.scene.GameScene.prototype.destroyLevel = function () {
  this._activePlatforms = null;
  this._currentPlatform = null;

  while (this._platforms.length > 0) {
    var platform = this._platforms.pop();

    if (platform.parent != null)
      platform.parent.removeChild(platform);
    EHDI.GetGlobalPool().platformPool.return(platform);
    platform = null;
  }

  this.destroyCollectibles();
}

EHDI.scene.GameScene.prototype.initCollectibles = function () {
  this._collectibles = [];
  this._activeCollectibles = [];

  var dataLength = this._collectibleData.length;

  for (var i = 0; i < dataLength; i++) {
    var collectible = EHDI.GetGlobalPool().collectiblePool.get();
    collectible.setup(this._collectibleData[i][0],
      this._collectibleData[i][1],
      this._collectibleData[i][2]);

    this._collectibles.push(collectible);
  }

  this.updateActiveCollectible();
};

EHDI.scene.GameScene.prototype.destroyCollectibles = function () {
  this._activeCollectibles = null;

  if(this._collectibles)
  {
    while (this._collectibles.length > 0) {
      var collectible = this._collectibles.pop();
  
      if (collectible.parent != null)
        collectible.parent.removeChild(collectible);
  
      EHDI.GetGlobalPool().collectiblePool.return(collectible);
      collectible = null;
    }
  }
  this._collectibles = null;
}

EHDI.scene.GameScene.prototype.updateCollectible = function () {
  this.updateActiveCollectible();
};

EHDI.scene.GameScene.prototype.updateActiveCollectible = function () {
  var collectibleGlobalX;
  var collectibleIndex;
  var gameWidth = this._gameWidth + 100;

  for (var i = 0; i < this._collectibles.length; i++) {
    var collectible = this._collectibles[i];

    collectible.update(this._platformContainer.x);

    if ((collectible.getLeftX() > gameWidth ||
    collectible.getRightX() < -100)) {
      collectibleIndex = this._activeCollectibles.indexOf(collectible);

      if (collectibleIndex != -1) {
        this._activeCollectibles.splice(collectibleIndex, 1);
        this._gameContainer.removeChild(collectible);
      }
    } else {
      collectibleIndex = this._activeCollectibles.indexOf(collectible);

      if (collectibleIndex == -1) {
        this._gameContainer.addChildAt(collectible, 1);
        this._activeCollectibles.push(collectible);
      }
    }
  }
};

EHDI.scene.GameScene.prototype.updateActivePlatform = function () {
  var platformGlobalX;
  var platformIndex;

  for (var i = 0; i < this._platforms.length; i++) {
    var platform = this._platforms[i];
    platformGlobalX = platform.getPlatformXPos() + this._platformContainer.x;

    if (platformGlobalX > this._gameWidth || platformGlobalX + platform.getWidth() < 0) {
      platformIndex = this._activePlatforms.indexOf(platform);

      if (platformIndex != -1) {
        this._platformContainer.removeChild(platform);
        this._activePlatforms.splice(platformIndex, 1);
      }
    } else {
      platformIndex = this._activePlatforms.indexOf(platform);

      if (platformIndex == -1) {
        this._activePlatforms.push(platform);
        // this._platformContainer.addChild(platform);
        this.managePlatformDepthSwap();
      }

      platform.update(this._platformContainer.x);
    }
  }
};

EHDI.scene.GameScene.prototype.managePlatformDepthSwap = function () {
  this._activePlatforms.sort(this.sortPlatform);

  for (var i = 0; i < this._activePlatforms.length; i++) {
    this._platformContainer.addChildAt(this._activePlatforms[i], i);
  }
};

EHDI.scene.GameScene.prototype.sortPlatform = function (platform1, platform2) {
  if (platform1.getHeight() == platform2.getHeight()) {
    return 0;
  } else if (platform1.getHeight() < platform2.getHeight()) {
    return 1;
  } else {
    return -1;
  }
};

EHDI.scene.GameScene.prototype.updateBackground = function (delta) {
    this.updateBackgroundNHLimit(this._backgroundTilingSprite);
    this._backgroundTilingSprite.tilePosition.x -= 0.02 * delta;

    // this.updateBackgroundNHLimit(this._backgroundRainTilingSprite);
    // this._backgroundRainTilingSprite.tilePosition.x -= 0.2 * delta;
    // this.updateBackgroundPVLimit(this._backgroundRainTilingSprite);
    // this._backgroundRainTilingSprite.tilePosition.y += 0.4 * delta;
    this.updateBackgroundNHLimit(this._backgroundFastRainTilingSprite);
    this._backgroundFastRainTilingSprite.tilePosition.x -= 0.3 * delta;
    this.updateBackgroundPVLimit(this._backgroundFastRainTilingSprite);
    this._backgroundFastRainTilingSprite.tilePosition.y += 0.6 * delta;
  };

EHDI.scene.GameScene.prototype.updatePlatform = function (delta) {
  if (-this._platformScrollLimit < this._platformContainer.x) {
    this._platformContainer.x -= this._character.getSpeed() * delta;

    if (-this._platformScrollLimit >= this._platformContainer.x) {
      this._platformContainer.x = -this._platformScrollLimit;
      this._noahSprite.x = 800;
      this._noahSprite.visible = true;

      this._noahVisible = true;

      this._noahsTimeLine = TweenLite.to(this._noahSprite, 0.4, {x:730});
    }


    this._currentGameDistance = Math.abs(this._platformContainer.x);

    this.updateActivePlatform();
  } else {
    this._character.moveXPos(this._character.getSpeed() * delta);

    if (this._gameContainer.getChildIndex(this._platformContainer) == 0 && this._character.x > 650)
      this._gameContainer.setChildIndex(this._platformContainer, this._gameContainer.children.length - 1);
    // if(this._character.x > 350 && this._character.getCharacterState() == EHDI.game.CharacterStateEnum.RUNNING)
    // {
    //   this._character.updateYPos(this.getEndPlatformY());
    // }

    for (var i = 0; i < this._tails.length; i++) {
      this._tails[i].setTargetXPos(this._character.x);
      this._tails[i].updateHorMovement(delta);
    }
  }

};

EHDI.scene.GameScene.prototype.checkCurrentPlatformPos = function () {
  if (this._character.x >= this._finishLine) {
    this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);

    this.addAnimalPairScore();

    this._hudPauseButton.endGame();

    this._floodAnimation.stop();

    if ( !EHDI.GAME.constants.gameEndFunction ) {
      EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp
        (this.getStar(this._scoreContainer.getScore()), this._scoreContainer.getScore()),
        {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(),
        EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
    else EHDI.GAME.constants.gameEndFunction();
    /* var score = this._scoreContainer.getScore();
    if(score > EHDI.GAME.saveData.highScore) {
        EHDI.GAME.saveData.highScore = score;
        EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        });
    }
    EHDI.sbGame.end(score); */
  }
};

EHDI.scene.GameScene.prototype.addAnimalPairScore = function () {
  var animalTypeArray = [];
  var additionalScore = 0;

  for(var i = 0; i < this._tails.length; i++) {
    if (animalTypeArray.indexOf(this._tails[i].getType()) == -1)
      animalTypeArray.push(this._tails[i].getType());
    else
      additionalScore += 200;
  }

  if (additionalScore != 0)
    this._scoreContainer.addScore(additionalScore);
};

EHDI.scene.GameScene.prototype.getStar = function (score) {
  if (score >= 1800)
    return 3;
  else if (score >= 1200)
    return 2;
  else if (score >= 800)
    return 1;
  else {
    return 0;
  }
}

EHDI.scene.GameScene.prototype.updateBackgroundNHLimit = function (tilingSprite) {
  if (tilingSprite.tilePosition.x < -tilingSprite.texture.width) {
    tilingSprite.tilePosition.x =
    tilingSprite.tilePosition.x + tilingSprite.texture.width;
  }
};

EHDI.scene.GameScene.prototype.updateBackgroundPVLimit = function (tilingSprite) {
  if (tilingSprite.tilePosition.y > tilingSprite.texture.height) {
    tilingSprite.tilePosition.y =
    tilingSprite.tilePosition.y - tilingSprite.texture.height;
  }
};

EHDI.scene.GameScene.prototype.checkCharacterAndCollectibleCollision = function () {
  var collectible;
  var removeCollectible = false;

  for (var i = 0; i < this._activeCollectibles.length; i++) {
    collectible = this._activeCollectibles[i];

    if (EHDI.CollisionManager.testRectCollision
    (this._character.getHitbox(), collectible.getHitbox()) &&
    this._character.y <= collectible.y + 1 &&
    this._character.x >= collectible.x &&
    this._character.getCharacterState() != EHDI.game.CharacterStateEnum.JUMP) {
      removeCollectible = true;
      this.spawnTail(collectible.x, collectible.y, collectible.getAnimation(), collectible.getType());
      break;
    }
  }

  if (removeCollectible) {
    this._activeCollectibles.splice(this._activeCollectibles.indexOf(collectible), 1);
    this._collectibles.splice(this._collectibles.indexOf(collectible), 1);
    this._gameContainer.removeChild(collectible);
    EHDI.GetGlobalPool().collectiblePool.return(collectible);
  }
};

EHDI.scene.GameScene.prototype.checkCharacterVerticalCollision = function () {
  var platform;

  if (this._character.getCharacterState() == EHDI.game.CharacterStateEnum.FALL) {
    for (var i = 0; i < this._activePlatforms.length; i++) {
      platform = this._activePlatforms[i];

      if (EHDI.CollisionManager.testRectCollision
      (this._character.getHitbox(), platform.getHitbox()) &&
      this._character.getPrevY() <= platform.getplatformY()) {

        this._character.collidedWithAPlatform(platform.getplatformY() + 1);
        this._currentPlatform = platform;
        break;
      }
    }

    if (this._character.y >= this._gameHeight) {
      this.spawnSplash(this._character.x,this._character.y - 20);
      this._character.collidedWithAPlatform(this._gameHeight);
      this._removeATail = true;
      this._floodPenaltyTimer.reset();
    }
  } else if (this._character.getCharacterState() == EHDI.game.CharacterStateEnum.RUNNING) {
    if (!EHDI.CollisionManager.testRectCollision
    (this._character.getHitbox(), this._currentPlatform.getHitbox()) &&
    this._character.y < this._gameHeight) {
        this._character.fall(true);
    } else if (this._character.y == this._gameHeight) {
      if (this._floodPenaltyTimer.getTimeInMilliseconds() >= this._floodPenaltyVal) {
        this.RemoveATail();
        this._floodPenaltyTimer.reset();
      }

      if (-this._platformScrollLimit + 100 >= this._platformContainer.x)
        this._jumpCharacter();
    }

    if (this._character.x  >= 300 && this._character.x <= 800)
      this._jumpCharacter();
    else if (this._noahVisible && this._character.x >= 950)
      this._noahsTimeLine = TweenLite.to(this._noahSprite, 0.4, {x:800});
  }
};

EHDI.scene.GameScene.prototype.getEndPlatformY = function (xPos) {
  if (xPos > 660)
    return this._gameHeight - 267;
  else if (xPos > 280) {
    return this._gameHeight - ((xPos - 280) * 0.6675);
  } else {
    return this._gameHeight;
  }
};

EHDI.scene.GameScene.prototype.checkTailVerticalCollision = function (tail) {
  var platform;

  if (tail.getTailState() == EHDI.game.TailStateEnum.FALL) {
    for (var i = 0; i < this._activePlatforms.length; i++) {
      platform = this._activePlatforms[i];

      if (EHDI.CollisionManager.testRectCollision
      (tail.getHitbox(), platform.getHitbox()) &&
      tail.getPrevY() <= platform.getHitbox().getGlobalTopY()) {

        tail.collidedWithAPlatform(platform.getHitbox().getGlobalTopY() + 1);
        tail.setPlatform(platform);
        break;
      }
    }

    if (tail.y >= this._gameHeight) {
      this.spawnSplash(tail.x,tail.y - 20);
      tail.collidedWithAPlatform(this._gameHeight);
    }
  } else if (tail.getTailState() == EHDI.game.TailStateEnum.RUNNING) {
    if (!EHDI.CollisionManager.testRectCollision
    (tail.getHitbox(), tail.getPlatform().getHitbox()) &&
    tail.y < this._gameHeight) {
      tail.fall(true);
    }
  }
};

EHDI.scene.GameScene.prototype.RemoveATail = function () {
  if (this._tails.length > 0) {
    var tail = this._tails.pop();

    this.spawnSplash(tail.x, tail.y - 20);

    this._tailTimeline = TweenLite.to(tail, 0.3, {y:800, onComplete:this.removeTailAnimationCompleted.bind(this, tail)});
  }
};

EHDI.scene.GameScene.prototype.removeTailAnimationCompleted = function (tail) {
  if (tail.parent != null)
    tail.parent.removeChild(tail);

  EHDI.GetGlobalPool().tailPool.return(tail);
  tail = null;
};

EHDI.scene.GameScene.prototype._jumpCharacter = function () {
  if (!this._hudPauseButton.isPaused){
    if (this._character.jump()) {
      for (var i = 0; i < this._tails.length; i++) {
        if (this._tails[i].x <= this._character.x)
          this._tails[i].headJumped(this._currentGameDistance + this._character.x);
      }
    }
  }
};

EHDI.scene.GameScene.prototype.spawnTail = function (xPos, yPos, animation, type) {
  var tail = EHDI.GetGlobalPool().tailPool.get();

  tail.init(this._character.getJumpVelY(), this._character.getGravity(), animation, type);
  tail.setTargetXPos(this._character.x);
  tail.start(xPos, yPos);

  this._tails.push(tail);

  this._gameContainer.addChildAt(tail, 1);

  this._pickupAnimation.getDisplay().x = this._character.x;
  this._pickupAnimation.getDisplay().y = this._character.y - 50;

  this._pickupAnimation.changeAnimation(false);

  this._scoreContainer.addScore(100);

  EHDI.GAME.soundManager.playSFX("animal_collect");
};

EHDI.scene.GameScene.prototype.spawnSplash = function (posX, posY) {
  var splashAnimation = EHDI.GetGlobalPool().splashPool.get();

  EHDI.GAME.soundManager.playSFX("fall_on_water_01");

  this._splashEffects.push(splashAnimation);

  splashAnimation.init('fx_splash');

  splashAnimation.updatePos(posX, posY);

  splashAnimation.changeAnimation(false);
  splashAnimation.addCompleteCallback(this.splashCompleted.bind(this, splashAnimation));
  this._foregroundContainer.addChildAt(splashAnimation.getDisplay(),0);
};

EHDI.scene.GameScene.prototype.splashCompleted = function (splash) {
  this._splashEffects.splice(this._splashEffects.indexOf(splash), 1);
  this._gameContainer.removeChild(splash);

  EHDI.GetGlobalPool().splashPool.return(splash);
}

EHDI.scene.GameScene.prototype.updateTails = function (delta) {
  for (var i = 0; i < this._tails.length; i++) {
    this._tails[i].update(delta, this._currentGameDistance);
    this.checkTailVerticalCollision(this._tails[i]);
    this._tails[i].updatePos();

    if (this._removeATail &&
    i == this._tails.length-1 &&
    this._tails[i].y == this._gameHeight) {
      this.RemoveATail();
      this._removeATail = false;
    }
  }
};

EHDI.scene.GameScene.prototype.updateCharacter = function (delta) {
  this._character.update(delta);

  this.checkCharacterVerticalCollision();

  this._character.updatePos();
};

EHDI.scene.GameScene.prototype.update = function (delta) {
  this._deltaTotal += delta * 25;
  if (this._deltaTotal >= this._deltaLimit) {
    this._deltaMultiplier = Math.floor(this._deltaTotal / this._deltaLimit);

    for (var i = 0; i < this._deltaMultiplier; i++) {
      this.gameUpdate(this._deltaLimit);
    }

    this._deltaTotal -= (this._deltaMultiplier * this._deltaLimit);
  }
};

EHDI.scene.GameScene.prototype.gameUpdate = function (delta) {
  if (!this._hudPauseButton.isPaused) {
    dragonBones.WorldClock.clock.advanceTime(delta * 0.001);

    if (this._gameState  == EHDI.GameStateEnum.GAMESTARTED) {
      this.updateBackground(delta);
      this.updatePlatform(delta);
      this.updateCollectible();
      this.updateClouds(delta);

      this.updateCharacter(delta);
      this.updateTails(delta);

      this.checkCharacterAndCollectibleCollision();

      this.checkCurrentPlatformPos();
    }
  }
};

EHDI.scene.GameScene.prototype.updateClouds = function (delta) {
  for (var i = 0; i<this._clouds.length; i++) {
    this._clouds[i].update(delta);
  }
}

EHDI.scene.GameScene.prototype._handler_onKeyDown = function (e) {
  if (e.keyCode == 32 && -this._platformScrollLimit + 300 < this._platformContainer.x) {
    this._jumpCharacter();
  }
};

EHDI.scene.GameScene.prototype._handler_onTouch = function (e) {
  if (e.target != this._hudPauseButton  && -this._platformScrollLimit + 300 < this._platformContainer.x)
    this._jumpCharacter();
};

EHDI.scene.GameScene.prototype.destroy = function () {
  console.log('destroy');

  this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);
  this.destroyListeners();
  this.destroyGraphics();
  EHDI.GetGlobalPool().gameScenePool.return(this);
};

EHDI.scene.GameScene.prototype.replay = function() {
  this.destroy();
  this.init();
  this.startGame();
}

EHDI.scene.GameScene.prototype.dispose = function() {
  this.destroy();
}